/*
 * Gag
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import { ifProp } from 'styled-tools';
import { palette } from 'styled-theme';

export type GagProps = {
  palette?: string,
  children?: React$Node,
  title?: React$Node,
  description?: React$Node,
  icon?: React$Node,
  filled?: boolean,
};

const GagWrapper = styled.div.attrs(() => ({
  testid: 'gag',
}))`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${ifProp('filled', '#fff', 'transparent')};
  z-index: 1;

  & > h4 {
    margin-bottom: 24px;
    font-size: 20px;
    font-weight: 600;
  }

  & > p {
    margin-bottom: 24px;
  }

  & > svg {
    color: ${palette(1)};
    margin-bottom: 22px;
  }
`;

/**
 * Gag React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {React$Node} [props.children] - childs
 * @param {string} [props.title] - gag title
 * @param {string} [props.description] - gag description
 * @param {React$Node} [props.icon] - gag icon
 * @param {boolean} [props.filled = true] - filled background
 * @param {string} [props.palette = 'primary'] - current button palette
 * @example <caption>Simple usage</caption>
 * <Gag title="title" description="description" />
 * @returns {React$Node} React-component
 */
export const Gag = ({
  icon,
  title,
  description,
  children,
  ...rest
}: GagProps) => (
  <GagWrapper {...rest} testid="gag">
    {icon}
    {title && <h4>{title}</h4>}
    {description && <p>{description}</p>}
    {children}
  </GagWrapper>
);

Gag.defaultProps = {
  palette: 'primary',
  testid: 'gag',
  filled: true,
};
